import { useQuery } from '@tanstack/react-query';
import { fetchMfaStatus, type MfaStatus } from '@/lib/api/mfa';

export function useMfaStatus() {
  const query = useQuery<MfaStatus>({
    queryKey: ['mfa-status'],
    queryFn: fetchMfaStatus,
  });
  const status = query.data;
  return {
    status,
    isLoading: query.isLoading,
    lowCodes: !!status && status.codes_remaining < 3,
    refetch: query.refetch,
  };
}
